export const AlertTypeEnum = Object.freeze({
    error: "error",
    warning: "warning",
    info: "info",
    success: "success"
})